import React from 'react'
import BaseQuery from '../../BaseQuery'
import { BaseQueryChildrenType } from '../../types/BaseQueryChildrenType'
import {useParams} from 'react-router-dom'
import { gql } from '@apollo/client'
import GenePage from './GenePage'
import {getDatasetId} from '@/utils/paramUtils'

const query = gql`
    query Gene($geneId: String, $geneSymbol: String, $datasetId: String!) {
        gene(gene_id: $geneId, gene_symbol: $geneSymbol, dataset_id: $datasetId) {
            gene_id
            gene_symbol
            name
            canonical_transcript_id
            chrom
            start
            stop
            transcript_ids
            variants {
                chrom
                ref
                alt
                length
                transcript_id_canonical
                source
                transcript_consequence_major {
                    gene_symbol
                    gene_id
                    consequence
                    transcript_id
                }
                source
                pos
                variant_id
                czechgenome_genome_frequencies {
                    population_subtype
                    variant_id
                    allele_stats {
                        allele_count
                        allele_number
                        homozygote_count
                        allele_frequency
                    }
                }
                clinical_significance
                rsids
            }
        }
    }
`

type Params = {
    gene: string
}

export default function GenePageContainer() {
    const { gene = '' } = useParams<Params>()
    const datasetId = getDatasetId()

    const variables = {
        [gene.startsWith('ENSG') ? 'geneId' : 'geneSymbol']: gene,
        ['datasetId']: datasetId
    }

    return (
        <BaseQuery
            query={query}
            variables={variables}
            loadingMessage='Loading gene'
            notFoundMessage='Gene not found'
        >
            {({ data }: BaseQueryChildrenType) => <GenePage gene={data.gene} />}
        </BaseQuery>
    )
}
